import { Check } from "lucide-react";
import { CrudPage } from "../components/CrudPage";
import { StatusBadge, fmt } from "../components/bits";

export default function Plans() {
  return (
    <CrudPage
      title="Planes de suscripción"
      subtitle="El costo mensual del colegio = precio por estudiante × estudiantes activos"
      endpoint="plans"
      base="/plans"
      testid="plans"
      canDelete
      enableViewToggle
      cardRender={(p, actions) => (
        <div key={p.id} className="bg-white border border-slate-200 rounded-2xl p-6 shadow-sm hover:shadow-md hover:-translate-y-1 transition-all flex flex-col" data-testid={`plan-card-${p.id}`}>
          <div className="flex items-start justify-between gap-2">
            <p className="font-bold text-lg text-slate-900">{p.name}</p>
            <StatusBadge value={p.active ? "activo" : "retirado"} />
          </div>
          <p className="mt-3">
            <span className="text-3xl font-bold text-blue-800">{fmt(p.price_per_student)}</span>
            <span className="text-sm text-slate-500"> /estudiante · {p.periodicity}</span>
          </p>
          <ul className="mt-4 space-y-1.5 flex-1">
            {(p.features || []).map((f) => (
              <li key={f} className="flex items-center gap-2 text-sm text-slate-600">
                <Check className="w-4 h-4 text-emerald-600 shrink-0" /> {f}
              </li>
            ))}
          </ul>
          <div className="mt-4 pt-3 border-t border-slate-100 flex justify-end">{actions}</div>
        </div>
      )}
      columns={[
        { key: "name", label: "Plan", render: (p) => <span className="font-medium text-slate-900">{p.name}</span> },
        { key: "price_per_student", label: "Precio / estudiante", render: (p) => <span className="font-semibold">{fmt(p.price_per_student)}</span> },
        { key: "periodicity", label: "Periodicidad" },
        { key: "features", label: "Incluye", render: (p) => <span className="text-xs text-slate-500">{(p.features || []).join(", ")}</span> },
        { key: "active", label: "Estado", render: (p) => <StatusBadge value={p.active ? "activo" : "retirado"} /> },
      ]}
      fields={[
        { key: "name", label: "Nombre del plan", type: "text", required: true },
        { key: "price_per_student", label: "Precio por estudiante (RD$)", type: "number" },
        { key: "periodicity", label: "Periodicidad", type: "select", options: [{ value: "Mensual", label: "Mensual" }, { value: "Anual", label: "Anual" }] },
        { key: "features", label: "Características (separadas por coma)", type: "textarea" },
        { key: "active", label: "Plan activo", type: "switch" },
      ]}
      transformPayload={(p) => ({ ...p, features: typeof p.features === "string" ? p.features.split(",").map((s) => s.trim()).filter(Boolean) : p.features })}
    />
  );
}
